export const api_url =
  process.env.REACT_APP_API_URL || "https://estimate395.com/v1";

// Shopify Admin product edit base URL (no trailing slash).
// Open: `${SHOPIFY_PRODUCT_STORE_URL}/${numericProductId}`
export const SHOPIFY_PRODUCT_STORE_URL = (
  process.env.REACT_APP_SHOPIFY_PRODUCT_STORE_URL || ""
).replace(/\/+$/, "");

// Shopify Admin collection edit base URL (no trailing slash).
// Falls back to replacing /products → /collections on the product admin URL.
export const SHOPIFY_COLLECTION_STORE_URL = (
  process.env.REACT_APP_SHOPIFY_COLLECTION_STORE_URL ||
  (SHOPIFY_PRODUCT_STORE_URL
    ? SHOPIFY_PRODUCT_STORE_URL.replace(/\/products\/?$/, "/collections")
    : "")
).replace(/\/+$/, "");

export const apiTimeOut = 600;

export const possibleNames = [
  "pack size",
  "pack size:",
  "pack qty",
  "pack quantity",
  "pack quantity:",
  "pack quantity.",
  "pack quantity.:",
  "pack qty.",
  "pack qty.:",
  "pack sizes",
  "pack sizes:",
];

export const CHANGE_STATUSES = {
  NEW: ["INPROGRESS", "COMPLETED", "CANCELLED"],
  INPROGRESS: ["COMPLETED", "CANCELLED"],
  CANCELLED: ["NEW"],
};

export const BANNER_TYPES = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const BANNER_DISPLAY = {
  [BANNER_TYPES.PRIMARY]: {
    cardWidth: 180,
    aspectRatio: "9 / 16",
    resolutionLabel: "9:16 (e.g. 1080 × 1920 px)",
  },
  [BANNER_TYPES.SECONDARY]: {
    cardWidth: 320,
    aspectRatio: "2144 / 496",
    resolutionLabel: "2144 × 496 px",
  },
};

export const extractIdFromGid = (gid) => {
  // Split the GID by "/"
  if (!gid) {
    return;
  }
  const parts = gid?.split("/");
  // Get the last part which should be the ID
  const id = parts[parts.length - 1];
  return id;
};

export const extractNumberFromString = (str) => {
  if (!str) {
    return {};
  }
  const match = str.match(/^(\d+)\s*(\D.*)$/);
  if (match) {
    const number = parseInt(match[1], 10);
    const unit = match[2].trim();
    return { number, unit };
  }
  return { number: str, unit: "PC" };
};
